import React from "react";

import { useForm } from "react-hook-form";

import { tw } from "@careinfo/tailwind";
import { yupResolver } from "@hookform/resolvers/yup/dist/yup";

import Button from "../Reusable/Button";
import DateRangePicker from "../Reusable/DateRangePicker";
import TextField from "../Reusable/TextInput";
import { emailDownloadValidationForm } from "../../utils/validationSchemas";

const EmailDownloadForm = ({ handleDownload, isLoading }) => {
  const {
    register,
    handleSubmit,
    setError,
    setValue,
    watch,
    formState: { errors },
    getValues,
  } = useForm<any>({
    resolver: yupResolver(emailDownloadValidationForm),
  });

  return (
    <form onSubmit={handleSubmit((data) => handleDownload(data, setError))}>
      <div className={tw`min-w-[400px] `}>
        <TextField
          label={"Email"}
          register={register("email")}
          errors={errors.email}
        />
        <DateRangePicker
          label={"Date Range"}
          setValue={setValue}
          name={"date_range"}
          getValues={getValues}
          errors={errors?.date_range}
        />
      </div>
      <div className={tw`mt-4`}>
        <Button label={"Download"} isLoading={isLoading} />
      </div>
    </form>
  );
};

export default EmailDownloadForm;
